<template>
	 <div class="tab-pane active" id="workouts" role="tabpanel">
        <div class="bg-white border-radius-5 p-3 workout-section mb-4">
            <div class="row mb-3">
                <div class="col-md-12">
                    <h2 class="mb-0">Gym</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3 mb-4 card border-0">
                    <div class="card-body border-0 bg-body border-radius-5 p-0 Exercise-product">
                        <figure class="mb-0 p-2"><img src="../../../../../static/website/images/exercise-1.png" alt="" /></figure>
                        <div class="px-2 pb-3">
                            <h3>Arms and legs gym workout</h3>
                            <p class="d-flex">
                                <span>18 min</span> | <span>Advanced</span> | <span><img src="../../../../../static/website/images/gym-dumbbell.png" /></span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 mb-4 card border-0">
                    <div class="card-body border-0 bg-body border-radius-5 p-0 Exercise-product">
                        <figure class="mb-0 p-2"><img src="../../../../../static/website/images/exercise-2.png" alt="" /></figure>
                        <div class="px-2 pb-3">
                            <h3>Arms and legs gym workout</h3>
                            <p class="d-flex">
                                <span>18 min</span> | <span>Advanced</span> | <span><img src="../../../../../static/website/images/gym-dumbbell.png" /></span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 mb-4 card border-0">
                    <div class="card-body border-0 bg-body border-radius-5 p-0 Exercise-product">
                        <figure class="mb-0 p-2"><img src="../../../../../static/website/images/exercise-3.png" alt="" /></figure>
                        <div class="px-2 pb-3">
                            <h3>Arms and legs gym workout</h3>
                            <p class="d-flex">
                                <span>18 min</span> | <span>Advanced</span> | <span><img src="../../../../../static/website/images/gym-dumbbell.png" /></span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 mb-4 card border-0">
                    <div class="card-body border-0 bg-body border-radius-5 p-0 Exercise-product">
                        <figure class="mb-0 p-2"><img src="../../../../../static/website/images/exercise-4.png" alt="" /></figure>
                        <div class="px-2 pb-3">
                            <h3>Arms and legs gym workout</h3>
                            <p class="d-flex">
                                <span>18 min</span> | <span>Advanced</span> | <span><img src="../../../../../static/website/images/gym-dumbbell.png" /></span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-white border-radius-5 p-3 workout-section mb-4">
            <div class="row mb-3">
                <div class="col-md-12">
                    <h2 class="mb-0">Walking</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3 mb-4 card border-0">
                    <div class="card-body border-0 bg-body border-radius-5 p-0 Exercise-product">
                        <figure class="mb-0 p-2"><img src="../../../../../static/website/images/exercise-5.png" alt="" /></figure>
                        <div class="px-2 pb-3">
                            <h3>Arms and legs gym workout</h3>
                            <p class="d-flex"><span>18 min</span> | <span>Advanced</span> |</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 mb-4 card border-0">
                    <div class="card-body border-0 bg-body border-radius-5 p-0 Exercise-product">
                        <figure class="mb-0 p-2"><img src="../../../../../static/website/images/exercise-6.png" alt="" /></figure>
                        <div class="px-2 pb-3">
                            <h3>Arms and legs gym workout</h3>
                            <p class="d-flex"><span>18 min</span> | <span>Advanced</span> |</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 mb-4 card border-0">
                    <div class="card-body border-0 bg-body border-radius-5 p-0 Exercise-product">
                        <figure class="mb-0 p-2"><img src="../../../../../static/website/images/exercise-7.png" alt="" /></figure>
                        <div class="px-2 pb-3">
                            <h3>Arms and legs gym workout</h3>
                            <p class="d-flex"><span>18 min</span> | <span>Advanced</span> |</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 mb-4 card border-0">
                    <div class="card-body border-0 bg-body border-radius-5 p-0 Exercise-product">
                        <figure class="mb-0 p-2"><img src="../../../../../static/website/images/exercise-8.png" alt="" /></figure>
                        <div class="px-2 pb-3">
                            <h3>Arms and legs gym workout</h3>
                            <p class="d-flex"><span>18 min</span> | <span>Advanced</span> |</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "exercise",
        data() {
            return {

            }
        },
        
    }
</script>


// WEBPACK FOOTER //
// src/components/website/exercise/pages/recent-exercise.vue